import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-head" }
const _hoisted_2 = { class: "backButton" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "product-param" }

import MagicZoom from '@/components/web/content/MagicZoom.vue'
import { ArrowLeft } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Product',
  props: {
    title: {},
    imageList: {},
    productInfo: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/case-studies",
        class: "back-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { class: "back-button" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "el-icon-arrow-left" }, null, -1),
              _createTextVNode(" Back ")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_row, { gutter: 30 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 14,
          lg: 14,
          xl: 14,
          class: "info-col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("dl", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("dt", null, "Manufacturing Process", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.ManufacturingProcess), 1),
              _cache[2] || (_cache[2] = _createElementVNode("dt", null, "Parts Material", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.PartsMaterial), 1),
              _cache[3] || (_cache[3] = _createElementVNode("dt", null, "Application Industry", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.ApplicationIndustry), 1),
              _cache[4] || (_cache[4] = _createElementVNode("dt", null, "Surface Treatment", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.SurfaceTreatment), 1),
              _cache[5] || (_cache[5] = _createElementVNode("dt", null, "Metal State", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.MetalState), 1),
              _cache[6] || (_cache[6] = _createElementVNode("dt", null, "Machine Used Type", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.MachineUsedType), 1),
              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Hardness Of Parts", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.HardnessOfParts), 1),
              _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Fillet", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.Fillet), 1),
              _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Demoulding Angle", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.DemouldingAngle), 1),
              _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Roughness", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.Roughness), 1),
              _cache[11] || (_cache[11] = _createElementVNode("dt", null, "Accuracy", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.Accuracy), 1),
              _cache[12] || (_cache[12] = _createElementVNode("dt", null, "8h Casting Times", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.productInfo.CastingTimes), 1)
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "product-service" }, [
              _createElementVNode("a", {
                href: "#form-feedback",
                class: "inquiry"
              }, "Inquiry Now"),
              _createElementVNode("a", {
                href: "/contact-us",
                class: "contact"
              }, [
                _createElementVNode("i", {
                  class: "far fa-envelope",
                  style: {"font-size":"14px","color":"#fff","margin-right":"0px"}
                }),
                _createTextVNode(" Contact Us ")
              ])
            ], -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 10,
          lg: 10,
          xl: 10,
          class: "image-col"
        }, {
          default: _withCtx(() => [
            _createVNode(MagicZoom, { imageList: _ctx.imageList }, null, 8, ["imageList"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})